import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  returnUrl = '/cs';

  constructor(
      private router: Router,
      public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

  goTo(url: string) {
    this.onClose();
    return this.router.navigate([url]);
  }

  onClose() {
    this.activeModal.close(false);
  }
}
